"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redPalette = void 0;
var tempusRed = '#D7303B';
var redPalette = {
  // TODO Possibly deprecating this color in v3, talk with Sarah W.
  redDark: '#B51F1A',
  red: tempusRed,
  tempusRed: tempusRed,
  cherryRed: '#C94F5F',
  redLight: '#EB979D',
  redLightest: '#EDE1E3' // error background

};
exports.redPalette = redPalette;